import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500">节目更新与平台公告</p>
          </div>
          <span className="text-xs text-foreground-400 whitespace-nowrap">共 {updatesData.length} 条动态</span>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updatesData.map((item, idx) => (
              <div key={item.id} className={`relative pb-8 ${idx === updatesData.length - 1 ? 'pb-0' : ''}`}>
                <div className={`absolute -left-[25px] top-1 w-3 h-3 rounded-full border-2 border-primary-200 ${
                  item.type === 'update' ? 'bg-primary-500' : 'bg-accent-500'
                }`}></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                  <span className="text-xs font-medium text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.date}
                  </span>
                  <span className={`text-xs font-medium px-1.5 py-0.5 rounded whitespace-nowrap ${
                    item.type === 'update'
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-accent-600 bg-accent-50'
                  }`}>
                    {item.type === 'update' ? '节目更新' : '平台公告'}
                  </span>
                </div>
                <h3 className="mt-2 text-sm font-medium text-foreground-800 leading-relaxed">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}